var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg"},[_c('BaseImg',{attrs:{"option":{
    style: {
      margin: '12px 0 0 16px',
      alignSelf: 'flex-start',
      width: '89px',
    },
    url: 'logo.png',
  }}}),_c('div',{staticClass:"coupon-box"},[_c('div',{staticClass:"coupon-list"},_vm._l((_vm.thisCouponList),function(v,i){return _c('div',{key:'coupon' + i,staticClass:"coupon-item",style:({background: 'url(' + _vm.imgHost + 'coupon' + v.picId + '.png?v=' + _vm.$OSSVersion + ') 0 0 / 100% no-repeat'})},[_c('div',{staticClass:"group-btn",on:{"click":function($event){return _vm.goTeam(v)}}},[_vm._v("去开团")]),_c('div',{staticClass:"detail",on:{"click":function($event){return _vm.toDetail(v)}}},[_vm._v("查看详情")])])}),0)]),_c('BaseBtnHome')],1)}
var staticRenderFns = []

export { render, staticRenderFns }